import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = [
  { q: "Where do you deliver?", a: "We currently deliver only within a 15 KM radius of our store in Sitapur, Uttar Pradesh. Enter your pincode on any product page to check availability instantly." },
  { q: "What delivery options are available?", a: "We offer Same Day Delivery (order before 4 PM), Next Day Delivery, and free Store Pickup from our Sitapur outlet." },
  { q: "What payment methods do you accept?", a: "We currently accept Cash on Delivery (COD). Online payments via UPI, Google Pay, PhonePe, Paytm and cards are coming soon." },
  { q: "Are your products fresh?", a: "Absolutely. Every batch is handpicked, quality-checked and packed fresh. We never use artificial preservatives." },
  { q: "How should I store dry fruits?", a: "Store in an airtight container in a cool, dry place away from direct sunlight. Nuts like walnuts are best refrigerated to preserve their oils." },
  { q: "Do you offer corporate and bulk gifting?", a: "Yes! Our Corporate Gifts collection offers premium hampers with custom branding available on bulk orders. Contact us for a quote." },
  { q: "Can I subscribe for regular delivery?", a: "Yes, select 'Subscribe & Save' on eligible product pages for convenient monthly deliveries of freshness." },
  { q: "How do I track my order?", a: "Use the Track Order page and enter your order number (sent on confirmation) to see live status." },
  { q: "What is your return policy?", a: "As we deal in food products, returns are accepted only for damaged or incorrect items reported within 24 hours of delivery. See our Refund Policy for details." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 fade-in">
      <div className="text-center mb-10">
        <span className="text-xs uppercase tracking-[0.3em] text-gold">Help Center</span>
        <h1 className="font-serif text-5xl text-forest mt-1">Frequently Asked Questions</h1>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-5 bg-white" data-testid={`faq-${i}`}>
            <AccordionTrigger className="font-serif text-lg text-forest text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
